import { useState } from "react";
import * as RadixTabs from "@radix-ui/react-tabs";
import styles from "./pill-tabs.module.css";

export interface TabsProps {
  tabs: string[]; // just a list of unique ids or tab names. providing names lets you skip providing 'triggerRender' in some cases
  defaultTab?: string; // first in list if not provided
  className?: string;

  triggerRender?: (tabId: string, tabIndex?: number) => React.ReactNode;
  contentRender?: (tabId: string, tabIndex?: number) => React.ReactNode;
  onTabChange?: (tabId: string, tabIndex?: number) => void;
}

export default function PillTabs(props: TabsProps) {
  const {
    tabs,
    defaultTab,
    className,

    triggerRender = (tabId: string, tabIndex: number): React.ReactNode => tabId,
    contentRender,
    onTabChange
  } = props;

  const [activeTab, setActiveTab] = useState<string>(defaultTab ?? tabs[0]);

  return (
    <RadixTabs.Root
      className={className}
      value={activeTab}
      onValueChange={e => {
        setActiveTab(e);
        onTabChange(e, tabs.findIndex(tabId => tabId === e));
      }}
    >
      <RadixTabs.List className={styles.tabs}>
        {tabs.map((tabId, i) => (
          <RadixTabs.Trigger key={tabId} value={tabId} className={styles.trigger}>
            {triggerRender(tabId, i)}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {contentRender && tabs.map((tabId, i) => (
        <RadixTabs.Content key={tabId} value={tabId} className={styles.content}>
          {contentRender(tabId, i)}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
